import { render, staticRenderFns } from "./discuss.vue?vue&type=template&id=4731a09a&scoped=true&"
import script from "./discuss.vue?vue&type=script&lang=js&"
export * from "./discuss.vue?vue&type=script&lang=js&"
import style0 from "./discuss.vue?vue&type=style&index=0&id=4731a09a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731a09a",
  null
  
)

export default component.exports